var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharedwithme(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3545 17.1419L13.3548 14.4637C13.3549 12.9844 12.1557 11.7851 10.6764 11.7851H4.67868C3.19957 11.7851 2.00047 12.9841 2.0003 14.4632L2 17.1419M17.9998 17.142L18 14.4639C18.0001 12.9846 16.8009 11.7853 15.3216 11.7853M12.8386 3.38335C13.4964 3.87138 13.9226 4.65376 13.9226 5.5357C13.9226 6.41764 13.4964 7.20002 12.8386 7.68806M10.4115 5.53556C10.4115 7.01479 9.21235 8.21394 7.73312 8.21394C6.25389 8.21394 5.05474 7.01479 5.05474 5.53556C5.05474 4.05633 6.25389 2.85718 7.73312 2.85718C9.21235 2.85718 10.4115 4.05633 10.4115 5.53556Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedwithme);
export default __webpack_public_path__ + "static/media/sharedwithme.443da71b5fd76224be677b959d401b3f.svg";
export { ForwardRef as ReactComponent };